import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController, ToastController, AlertController, LoadingController, MenuController } from '@ionic/angular';

import { AccountService } from '../../api/account.service';
import { AppSettings } from 'src/app/app-settings';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AppComponent } from '../../app.component'
import { AppVersion } from '@ionic-native/app-version/ngx';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  public onLoginForm: FormGroup;

  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';
  keepSignedIn: boolean = true;

  isWeb = AppSettings.IS_WEB;

  appNumber = undefined;

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private menuCtrl: MenuController,
    private appVersion: AppVersion,
    private inAppBrowser: InAppBrowser,
    private appcomponent: AppComponent
  ) { }

  ionViewWillEnter() {
    this.menuCtrl.enable(false);

    if (!this.isWeb) {
      this.appVersion.getVersionNumber().then(result => {
        this.appNumber = result
      }).catch(() => { })
    }
  }

  async ngOnInit() {
    this.accountService.checkLogin().then((isLogged) => {
      if (isLogged) {
        this.navCtrl.navigateRoot('tabs/tab1');
      } else {
        this.onLoginForm = this.formBuilder.group({
          'email': [null, Validators.compose([
            Validators.required
          ])],
          'password': [null, Validators.compose([
            Validators.required
          ])]
        });
      }
    })
  }

  async login() {
    let t = this;

    if (!this.onLoginForm.valid) {
      let errorMessage;
      if (!this.onLoginForm.value['email']) {
        errorMessage = "Please enter your email adress"
      } else {
        errorMessage = "Please enter your password"
      }
      const toast = await t.toastCtrl.create({
        color: 'light',
        showCloseButton: true,
        message: errorMessage,
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      return
    }

    const loader = await this.loadingCtrl.create({
      message: 'Signing in',
    });

    loader.present().then(() => {
      t.accountService.login(this.onLoginForm.value['email'], this.onLoginForm.value['password'], this.keepSignedIn)
        .then(() => {
          loader.dismiss().catch(() => { });
          t.navCtrl.navigateRoot('tabs/tab1');
          t.menuCtrl.enable(this.isWeb);
          this.accountService.setIsUserLoggedIn(true);
          this.appcomponent.getNotifications()
        })
        .catch(async error => {
          loader.dismiss().catch(() => { });
          let errorMsg = error.error[Object.keys(error.error)[0]][0];
          if (!!errorMsg) {
            const toast = await t.toastCtrl.create({
              color: 'warning',
              showCloseButton: true,
              message: errorMsg,
              duration: 3000,
              position: 'bottom'
            });

            toast.present();
          }
        });
    });
  }

  async forgotPassword() {
    let t = this;

    const alert = await this.alertCtrl.create({
      header: 'Forgot Password?',
      message: 'Enter you email address to send a reset link password.',
      cssClass: t.isWeb ? '' : 'top-alert',
      inputs: [
        {
          name: 'email',
          type: 'email',
          placeholder: 'Email'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        }, {
          text: 'Confirm',
          handler: async (data) => {
            const loader = await this.loadingCtrl.create({
              message: 'Sending mail'
            });

            loader.present().then(() => {
              t.accountService.forgottenPassword(data.email)
                .then(async () => {
                  loader.dismiss();
                  const toast = await this.toastCtrl.create({
                    color: 'light',
                    showCloseButton: true,
                    message: 'Email successfully sent.',
                    duration: 3000,
                    position: 'bottom'
                  });
                  toast.present();
                }).catch(async (error) => {
                  let errorMsg = error.error[Object.keys(error.error)[0]][0];

                  loader.dismiss();

                  if (!!errorMsg) {
                    const toast = await this.toastCtrl.create({
                      color: 'warning',
                      showCloseButton: true,
                      message: errorMsg,
                      duration: 3000,
                      position: 'bottom'
                    });
                    toast.present();
                  }
                });
            });
          }
        }
      ]
    });

    await alert.present();
  }

  // // //
  /*goToRegister() {
    this.navCtrl.navigateRoot('/register');
  }
*/

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

}
